import type { ErrorResponse } from '../../shared'
import type { PaginatedResults, RefundEntity } from './entities'
import { initContract } from '@ts-rest/core'
import z from 'zod'

const c = initContract()

const options = {
  pathPrefix: '/refunds',
}

export const paymentRefundsContract = c.router({
  getRefund: {
    method: 'GET',
    path: '/:refundId',
    pathParams: z.object({
      refundId: z.string(),
    }),
    responses: {
      200: c.type<RefundEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  getRefunds: {
    method: 'GET',
    path: '',
    query: z.object({
      count: z.optional(z.coerce.number().positive().max(100)).describe('Number of refunds to return'),
      offset: z.optional(z.coerce.number().positive()).describe('Offset for pagination'),
      referenceType: z.string().optional().describe('Filter refunds by reference type'),
      referenceId: z.string().optional().describe('Filter refunds by reference ID'),
    }).optional(),
    responses: {
      200: c.type<PaginatedResults<RefundEntity>>(),
      500: c.type<ErrorResponse>(),
    },
  },
}, options)
